// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import SectionDivider from '/react4xp/components/SectionDivider'

// prop types
export interface ProductHighlightsProps {
    className?: string
    highlights: {
        text: string
    }[]
}

export default function ProductHighlights({
    highlights,
    className
}: ProductHighlightsProps) {
    return (
        <>
            <SectionDivider />

            <Section
                className={clsx('product-highlights', className )}
                marginTop='none'
                marginBottom='none'
            >
                <div className='container'>
                    <ul className={clsx(
                        'product-highlights__list',
                        highlights.length === 1 && 'product-highlights__list--one',
                        highlights.length === 2 && 'product-highlights__list--two',
                        highlights.length === 3 && 'product-highlights__list--three'
                    )}>
                        {highlights.map((highlight, i) => (
                            <li
                                key={i}
                                className='product-highlights__item h3'
                            >
                                {highlight.text}
                            </li>
                        ))}
                    </ul>
                </div>
            </Section>

            <SectionDivider />

        </>
    )
}